import posthog from "posthog-js";
import { useEffect, useState } from "react";
import type { Event } from "../constants/events.js";

const posthogInstance = posthog.init(import.meta.env.VITE_POSTHOG_KEY,
  {
    api_host: `${window.location.origin}/analytics`,
    ui_host: "https://eu.posthog.com",
    person_profiles: "identified_only",
    defaults: "2026-01-30",
    autocapture: true,
    capture_exceptions: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
    },
  },
);

export function resetSession() {
  posthogInstance.reset();
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  posthogInstance.identify(userId, properties);
}

export function captureEvent(event: Event, properties?: Record<string, unknown>) {
  posthogInstance.capture(event, properties, {
    transport: "sendBeacon",
  });
}

export function isFeatureEnabled(feature: string) {
  return posthogInstance.isFeatureEnabled(feature);
}

/**
 * Flags load asynchronously and are re-evaluated after `identify()`, so a
 * one-off `isFeatureEnabled` read at mount is stale or undefined.
 */
export function useFeatureFlag(feature: string): boolean {
  const [enabled, setEnabled] = useState(() => isFeatureEnabled(feature) ?? false);

  useEffect(() => {
    return posthogInstance.onFeatureFlags(() => {
      setEnabled(isFeatureEnabled(feature) ?? false);
    });
  }, [feature]);

  return enabled;
}
